"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Shield, Target, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KeyBenefits() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const benefits = [{
    icon: Shield,
    title: "95% Scope Gap Reduction",
    description: "AI-powered detection identifies and eliminates scope gaps before they impact your project timeline or budget."
  }, {
    icon: Target,
    title: "Real-Time Project Insights",
    description: "Monitor project vitals, compliance status, and subcontractor performance through intelligent dashboards."
  }, {
    icon: Zap,
    title: "Seamless Integration",
    description: "Secure Egnyte integration ensures your data flows smoothly across all construction management workflows."
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="key-benefits" className="bg-background py-16 px-6 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} data-index={i} ref={refs[i]} className="transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
            opacity: visibilities[i] ? 1 : 0,
            transform: visibilities[i] ? "translateY(0)" : "translateY(20px)",
            transitionDelay: `${i * 200}ms`
          }}>
                <Card className="h-full bg-background shadow-soft hover:shadow-medium transition-shadow duration-[var(--duration-medium)]">
                  <CardContent className="flex flex-col items-center text-center gap-4">
                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10">
                      <Icon className="w-8 h-8 text-primary" />
                    </div>
                    <h3 className="text-xl font-bold text-foreground hover:text-primary transition-colors duration-[var(--duration-fast)]">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}